import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useSnapshot } from 'valtio';

import Loading from '../components/feedback/loading.jsx';
import { authState } from '../services/state/auth-state.jsx';
import { CATALYST_USER_ROLES } from '../utils/constants.js';

/**
 * Redirects to the appropriate route based on the user's role.
 * This page is used as the base route "/" of the app.
 *
 * @return {JSX.Element} Loading component
 */
export const Redirect = () => {
  const { user } = useSnapshot(authState);
  const navigate = useNavigate();

  useEffect(() => {
    const userRole = user?.details?.role;

    if (
      userRole === CATALYST_USER_ROLES.admin ||
      userRole === CATALYST_USER_ROLES.user ||
      userRole === CATALYST_USER_ROLES.user_admin ||
      userRole === CATALYST_USER_ROLES.tablet
    ) {
      navigate('/backoffice');
    } else {
      navigate('/portal');
    }
  }, []);

  return <Loading />;
};
